import type { ReactNode } from 'react';

export const symbol_currency_yuan: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-150v-242H270q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h177L229-794q-10-15-1.19-30.5T255-840q8.09 0 14.71 3.68 6.61 3.69 10.29 10.32l200 315 200-315q3.71-6.63 10.38-10.32 6.67-3.68 14.83-3.68Q723-840 732-824.5t-1 30.5L513-452h177q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H510v242q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
